import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    target: String,
    autoLoad: { type: Boolean, default: false }
  }

  connect() {
    this.boundHandleClick = this.handleClick.bind(this)

    if (this.autoLoadValue) {
      this.load()
    } else {
      this.element.addEventListener('click', this.boundHandleClick)
    }
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundHandleClick)
  }

  handleClick() {
    this.load()
  }

  async load() {
    const targetElement = this.getTargetElement()
    if (!targetElement) return

    this.showSpinner(targetElement)

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        targetElement.innerHTML = html
        this.executeScripts(targetElement)
      } else {
        this.showError(targetElement)
      }
    } catch (error) {
      console.error('AsyncLoadController: Error loading content:', error)
      this.showError(targetElement)
    }
  }

  getTargetElement() {
    if (this.hasTargetValue) {
      const el = document.getElementById(this.targetValue)
      if (!el) console.error('AsyncLoadController: Target not found:', this.targetValue)
      return el
    }
    return this.element
  }

  showSpinner(element) {
    element.innerHTML = `
      <div class="modal-body text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    `
  }

  showError(element) {
    element.innerHTML = `
      <div class="modal-body">
        <div class="alert alert-danger mb-0">Fehler beim Laden</div>
      </div>
    `
  }

  executeScripts(container) {
    container.querySelectorAll('script').forEach(script => {
      const newScript = document.createElement('script')
      newScript.textContent = script.textContent
      script.parentNode.replaceChild(newScript, script)
    })
  }
}

